import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash === '') { // Only scroll to top if there is no hash
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]); // Re-run effect when pathname or hash changes

  return null;
}

export default ScrollToTop;
